import AccordionItem from "theme/components/accordions/AccordionItem";
import CmsModules from "theme/libs/wordpress/content/CmsModules";
import Column from "theme/layouts/Column";
import CustomerServiceHero from "theme/components/customerService/CustomerServiceHero";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import colors from "theme/config/colors";
import FAQStructuredData from "core-web/components/Meta/StructuredData/FAQStructuredData.js";
import { useSelector } from "react-redux";

const Faq = () => {
    const pageContent = useSelector(({ page }) => page.data?.page_content);
    const { faq } = useSelector(({ page }) => page.data.faq || {});

    return (
        <>
            <CustomerServiceHero />

            {(faq || []).map((faqSection, sectionIndex) => (
                <Column key={sectionIndex} gap="32px">
                    {faqSection.heading?.text?.[0]?.length && (
                        <Wysiwyg
                            data={faqSection.heading?.text}
                            textComponent={(props) => (
                                <TextStyles
                                    as="h3"
                                    textStyles={[
                                        "Myriad Pro/24-100-semibold",
                                        null,
                                        null,
                                        null,
                                        "Myriad Pro/32-120-semibold",
                                    ]}
                                    {...props}
                                />
                            )}
                        />
                    )}
                    <Column gap="16px">
                        {(faqSection.questions || []).map((question, index) => (
                            <AccordionItem
                                key={`${question.answer?.[0]}-${index}`}
                                id={`${sectionIndex}-${index}`}
                                label={question.question}
                                typography="Myriad Pro/20-130-semibold"
                            >
                                <Wysiwyg
                                    data={question.answer}
                                    textComponent={(props) => (
                                        <TextStyles textStyles="Myriad Pro/16-120" color={colors.black_70} {...props} />
                                    )}
                                />
                            </AccordionItem>
                        ))}
                    </Column>
                </Column>
            ))}
            <FAQStructuredData
                questions={(faq || []).flatMap((item) =>
                    item.questions.map(({ question, answer }) => ({ title: question, text: answer })),
                )}
            />
            {!!pageContent?.length && <CmsModules isCustomerService isWithoutBleedWrapper data={pageContent} />}
        </>
    );
};

export default Faq;
